import React from "react";
import moment from "moment";
import { View, Text, StyleSheet, Platform } from "react-native";
import AppTheme from "../../AppTheme";

import { getMoodById } from "../../common/mood/MoodsHelper";

export default function ReportJournal({ journal }) {
  const moodIcon = getMoodById(journal.mood);
  const datetime = moment(journal.datetime_created).format("hh:mma, MM/DD/YY");

  return (
    <View style={styles.journal}>
      <View style={styles.row}>
        <moodIcon.Icon selected={true} width={24} height={24} />
        <View style={{ marginLeft: 12 }}>
          <Text style={styles.title}>{journal.name}</Text>
          <Text style={styles.date}>Logged at {datetime}</Text>
        </View>
      </View>
      <Text style={styles.text}>{journal.text}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  row: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
  },
  title: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
  },
  date: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-Regular" }),
    fontWeight: "300",
    fontSize: 12,
    lineHeight: 14,
    letterSpacing: 0.5,
    color: AppTheme.almostBlack,
  },
  text: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-Regular" }),
    fontWeight: "300",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.5,
    color: AppTheme.almostBlack,
    marginTop: 3,
  },
});
